<template>
  <div class="admin-organizations-page container">
    <breadcrumbs
      :breadcrumb-links="[{url:adminHomeURL, text: 'Admin home'},{text: 'Duplicates'}]"
    />
    <div class="row">
      <div class="col-12 card">
        <h2>Duplicates list</h2>
        <p>
          Below is a list of recipients whose data may have been duplicated in our system. Click the alert button to view organization contact information for the flagged duplicate.
        </p>
        <duplicates-table />
      </div>
    </div>
  </div>
</template>

<script>
import DuplicatesTable from '../../components/Admin/DuplicatesTable';
import metadata from '../../util/metadata';
import routeNames from '../../util/routeNames';
import Breadcrumbs from '../../components/Breadcrumbs';

export default {
  name: 'AdminDuplicates',
  components: { DuplicatesTable, Breadcrumbs },
  data() {
    return {
      adminHomeURL: routeNames.ADMIN.PATH
    }
  },
  metaInfo: {
    title: `Duplicates | Admin | ${metadata.GLOBAL.PAGE_TITLE}`,
    meta: [
      { name: 'description', content: 'Administration dashboard for managing duplicates for The Salvation Army' }
    ]
  },
}
</script>
